'use client'

import { useState, useEffect } from 'react'

import Spotlight from '@/app/_components/Spotlight'
import HomeFeaturedProducts from '@/app/(home)/HomeFeaturedProducts'

const TradeSpotlightsSection = () => {
    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        // Fetch via Route Handler (not Server Action) to avoid bot/crawler RSC errors
        const loadSpotlights = async () => {
            try {
                const response = await fetch('/api/trade/spotlights')
                const result = await response.json()
                setData(result)
            } catch (error) {
                setData(null)
            }
            setIsLoading(false)
        }
        loadSpotlights()
    }, [])

    if (isLoading) {
        return (
            <>
                {/* Supplier Spotlight Skeleton */}
                <div className="mb-4 lg:mb-6 w-full">
                    <div className="site-padding animate-pulse">
                        <div className="flex flex-col lg:flex-row gap-4 lg:gap-6">
                            <div className="lg:w-1/2 bg-gray-100 aspect-[4/3] rounded"></div>
                            <div className="lg:w-1/2 flex flex-col justify-center gap-3 lg:gap-4">
                                <div className="h-6 lg:h-8 bg-gray-100 rounded w-1/2"></div>
                                <div className="h-3 lg:h-4 bg-gray-100 rounded w-3/4"></div>
                                <div className="h-3 lg:h-4 bg-gray-100 rounded w-2/3"></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Designer Spotlight Skeleton */}
                <div className="mb-4 lg:mb-6 w-full">
                    <div className="site-padding animate-pulse">
                        <div className="flex flex-col lg:flex-row-reverse gap-4 lg:gap-6">
                            <div className="lg:w-1/2 bg-gray-100 aspect-[4/3] rounded"></div>
                            <div className="lg:w-1/2 flex flex-col justify-center gap-3 lg:gap-4">
                                <div className="h-6 lg:h-8 bg-gray-100 rounded w-1/2"></div>
                                <div className="h-3 lg:h-4 bg-gray-100 rounded w-3/4"></div>
                                <div className="h-3 lg:h-4 bg-gray-100 rounded w-2/3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    if (!data) {
        return null
    }

    return (
        <>
            <div className="mb-4 lg:mb-6 w-full">
                <Spotlight
                    spotlights={data.supplierSpotlights}
                    supplier={data.supplier}
                    orientation="ltor"
                />
            </div>

            <div className="mb-8 lg:mb-12 w-full">
                <Spotlight
                    spotlights={data.designerSpotlights}
                    designer={data.designer}
                    orientation="rtol"
                />
            </div>

            <HomeFeaturedProducts
                products={data.featuredProducts}
                heading={data.featuredProductsHeading}
                url={data.featuredProductsUrl}
            />
        </>
    )
}

export default TradeSpotlightsSection
